__turbopack_context__.v({
  "group": "Radio-module-scss-module__UGCtha__group",
  "group--disabled": "Radio-module-scss-module__UGCtha__group--disabled",
  "group__label": "Radio-module-scss-module__UGCtha__group__label",
  "group__label--checked": "Radio-module-scss-module__UGCtha__group__label--checked",
  "group__label__radio": "Radio-module-scss-module__UGCtha__group__label__radio",
  "radio_effect_in": "Radio-module-scss-module__UGCtha__radio_effect_in",
});
